import { Injectable } from '@angular/core';
import { HttpClient, } from '@angular/common/http';
import { Observable, Subject, } from 'rxjs';
import { DataStateChangeEventArgs, } from '@syncfusion/ej2-angular-grids';
import { map } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { GeneralService } from 'src/app/service/general.service';
import { DatePipe } from '@angular/common';
@Injectable({
  providedIn: "root",
})
export class ClientCreateEditCareService extends Subject<DataStateChangeEventArgs> {
  constructor(private http: HttpClient, public global: GlobalComponent, public general: GeneralService,public datepipe: DatePipe,) {
    super();
  }
  public outputValuesCareCoordinator(state): void {
    this.getClientCarecoodinator(state).subscribe(x => super.next(x));
  }
  getClientCarecoodinator(state): Observable<DataStateChangeEventArgs> {
    let url = "api/ClientCareCoordinatorRelationship/GetClientCoordinatorRelationshipList";
    if(this.global.referralId !== "00000000-0000-0000-0000-000000000000")
      url = "api/ReferralCareCoordinatorRelationship/GetReferralCoordinatorRelationshipList"
    return this.http.post<any>(url, state)
      .pipe(map(
        (response: any) => (<any>{
          result: response['result'],
          count: response['count']
        }))).pipe(map((e: any) => {
          e.result.forEach(element => {
            element.alternateFax = (element.alternateFax != null) ? this.general.converPhoneGoogleLib(element.alternateFax) : null;
            element.fax = (element.fax != null) ? this.general.converPhoneGoogleLib(element.fax) : null;
            element.phoneNumber = (element.phoneNumber != null) ? this.general.converPhoneGoogleLib(element.phoneNumber) : null;

          })
          return e;
        })

        )
  }


  public outputValuesFMSAgency(state): void {
    this.getClientFMSAgency(state).subscribe(x => super.next(x));
  }
  getClientFMSAgency(state): Observable<DataStateChangeEventArgs> {
         return this.http.post<any>("api/ClientFMSAgencyRelationship/GetFMSAgencyRelationshipList", state)
            .pipe(map(
                (response: any) =>
                    <any>{
                        result: response['result'],
                        count: response['count']
                    }
            ))
                        .pipe(
        map((e: any) => {
          e.result.forEach((element) => {
        element.activeDate = this.datepipe.transform(element?.activeDate, 'MM/dd/yyyy')
         element.inActiveDate = this.datepipe.transform(element?.inActiveDate, 'MM/dd/yyyy')
          });
          return e;
        })
      );
  }

    public outputValuesHHAAgency(State): void {
          this.getHHAFilter(State).subscribe(x => super.next(x));
      }
      getHHAFilter(State): Observable<DataStateChangeEventArgs> {
          return this.http.post<any>("api/ClientHHAgencyRelationship/GetHHAgencyRelationshipList", State)
              .pipe(map(
                  (response: any) =>
                      <any>{
                          result: response['result'],
                          count: response['count']
                      }
              ))
                 .pipe(
        map((e: any) => {
          e.result.forEach((element) => {
        element.activeDate = this.datepipe.transform(element?.activeDate, 'MM/dd/yyyy')
         element.inActiveDate = this.datepipe.transform(element?.inActiveDate, 'MM/dd/yyyy')
          });
          return e;
        })
      );
      }

}
